import axios from 'axios';
import { Component } from "react";
import { baseUrl, contentUrl, config } from './index.js';

export default class DashboardService extends Component {
  static getOpportunitiesForStudents = async () => {
    try {
      config.url = contentUrl + (localStorage.getItem('localLang') === 'en' ? '/' : localStorage.getItem('localLang') + '/') + 'wp-json/wp/v2/pages/451'
      config.method = 'get';
      config.params = '';
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getAyushChairs = async () => {
    try {
      config.url = contentUrl + (localStorage.getItem('localLang') === 'en' ? '/' : localStorage.getItem('localLang') + '/') + 'wp-json/wp/v2/pages/453'
      config.method = 'get';
      config.params = '';
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getAyushGlobal = async () => {
    try {
      config.url = contentUrl + (localStorage.getItem('localLang') === 'en' ? '/' : localStorage.getItem('localLang') + '/') + 'wp-json/wp/v2/pages/449'
      config.method = 'get';
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getHelpFeedback = async () => {
    try {
      config.url = contentUrl + (localStorage.getItem('localLang') === 'en' ? '/' : localStorage.getItem('localLang') + '/') + 'wp-json/wp/v2/pages/456'
      config.method = 'get';
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getWebsitePolicies = async () => {
    try {
      config.url = contentUrl + (localStorage.getItem('localLang') === 'en' ? '/' : localStorage.getItem('localLang') + '/') + 'wp-json/wp/v2/pages/458'
      config.method = 'get';
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };
  
  static getTermsConditions = async () => {
    try {
      config.url = contentUrl + (localStorage.getItem('localLang') === 'en' ? '/' : localStorage.getItem('localLang') + '/') + 'wp-json/wp/v2/pages/460'
      config.method = 'get';
      const response = await axios(config);
      return response ? response : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getDashboardData = async () => {
    try {
      config.url = baseUrl + '/wp/v2/homepage_data?lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      const response = await axios(config);
      return response ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

  static getSearchResults = async (data) => {
    try {
      config.url = baseUrl + '/wp/v2/get_global_search?s=' + data + '&lang=' + localStorage.getItem('localLang');
      config.method = 'get';
      const response = await axios(config);
      return response ? response.data : [];
    } catch (error) {
      const { response } = error;
      if (!response) return;
      console.log(`FETCH GET ERROR`, response);
    }
  };

}
